
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "jst/ExternalTools/_external_tools_menu";
import "i18n!quizzes.quiz_item_view";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'quizzes/QuizItemView';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, helper, self=this, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    class=\"\n    ig-row\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.publishable), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.published), {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ig-editable\"\n  ";
  return buffer;
  }
function program2(depth0,data) {
  
  
  return "ig-publishable";
  }

function program4(depth0,data) {
  
  
  return "ig-published";
  }

function program6(depth0,data) {
  
  
  return "\n    class=\"ig-row\"\n  ";
  }

function program8(depth0,data) {
  
  
  return "\n        <div class=\"ig-details__item date-available\" data-view=\"date-available\"></div>\n        ";
  }

function program10(depth0,data) {
  
  
  return "\n        <div class=\"ig-details__item date-due\" data-view=\"date-due\"></div>\n        ";
  }

function program12(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n          <div class=\"ig-details__item\">";
  if (helper = helpers.possible_points_label) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.possible_points_label); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</div>\n        ";
  return buffer;
  }

function program14(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n          <div class=\"ig-details__item\">";
  if (helper = helpers.question_count_label) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.question_count_label); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</div>\n        ";
  return buffer;
  }

function program16(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <div class=\"ig-admin\">\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.isTrigger), {hash:{},inverse:self.noop,fn:self.program(17, program17, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.isReleased), {hash:{},inverse:self.noop,fn:self.program(19, program19, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      <span class=\"sis-button\" data-view=\"sis-button\"></span>\n      <span data-view=\"lock-icon\" class=\"lock-icon\"></span>\n      <span data-view=\"publish-icon\" class=\"publish-icon\"></span>\n\n      <div class=\"inline-block\">\n        <a class=\"al-trigger al-trigger-gray\" role=\"button\" aria-haspopup=\"true\" aria-owns=\"ui-id-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-1\" href=\"#\">\n          <i class=\"icon-more\" aria-hidden=\"true\"></i>\n          <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title_label': ((depth0 && depth0.title_label)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "options_for_title_label_17f821ff", "Options for %{title_label}", options) : helperMissing.call(depth0, "t", "options_for_title_label_17f821ff", "Options for %{title_label}", options)))
    + "</span>\n        </a>\n\n        <ul id=\"ui-id-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-1\" class=\"al-options\" role=\"menu\" tabindex=\"0\" aria-hidden=\"true\" aria-expanded=\"false\" aria-activedescendant=\"ui-id-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-2\">\n          <li role=\"presentation\">\n            <a href=\"";
  if (helper = helpers.edit_url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.edit_url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" id=\"ui-id-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-2\" class=\"icon-edit\" tabindex=\"-1\" role=\"menuitem\" title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "edit_quiz_ededddd8", "Edit Quiz", options) : helperMissing.call(depth0, "t", "edit_quiz_ededddd8", "Edit Quiz", options)))
    + "'>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "edit_c5fbea07", "Edit", options) : helperMissing.call(depth0, "t", "edit_c5fbea07", "Edit", options)))
    + "</a>\n          </li>\n          ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.isCyoeAble), {hash:{},inverse:self.noop,fn:self.program(21, program21, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.is_locked), {hash:{},inverse:self.noop,fn:self.program(23, program23, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.migrateQuizEnabled), {hash:{},inverse:self.noop,fn:self.program(28, program28, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  stack1 = self.invokePartial(partials['ExternalTools/external_tools_menu'], 'ExternalTools/external_tools_menu', (depth0 && depth0.quiz_menu_tools), helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </ul>\n      </div>\n    </div>\n    ";
  return buffer;
  }
function program17(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <a href=\"";
  if (helper = helpers.edit_url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.edit_url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "?return_to=";
  if (helper = helpers.return_to) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.return_to); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "#mastery-paths-editor\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title_label': ((depth0 && depth0.title_label)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "edit_mastery_paths_for_title_label_41d81451", "Edit Mastery Paths for %{title_label}", options) : helperMissing.call(depth0, "t", "edit_mastery_paths_for_title_label_41d81451", "Edit Mastery Paths for %{title_label}", options)))
    + "\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "mastery_paths_cc4096c2", "Mastery Paths", options) : helperMissing.call(depth0, "t", "mastery_paths_cc4096c2", "Mastery Paths", options)))
    + "</a>\n      ";
  return buffer;
  }

function program19(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <span class=\"pill mastery-path-icon\" aria-hidden=\"true\" data-tooltip title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'cyoe.releasedLabel': (((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.releasedLabel)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "released_by_mastery_path_cyoe_releasedlabel_14c67a92", "Released by Mastery Path: %{cyoe.releasedLabel}", options) : helperMissing.call(depth0, "t", "released_by_mastery_path_cyoe_releasedlabel_14c67a92", "Released by Mastery Path: %{cyoe.releasedLabel}", options)))
    + "\">\n        <i class=\"icon-mastery-path\"></i>"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.releasedLabel)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\n      </span>\n      <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'cyoe.releasedLabel': (((stack1 = (depth0 && depth0.cyoe)),stack1 == null || stack1 === false ? stack1 : stack1.releasedLabel)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "released_by_mastery_path_cyoe_releasedlabel_14c67a92", "Released by Mastery Path: %{cyoe.releasedLabel}", options) : helperMissing.call(depth0, "t", "released_by_mastery_path_cyoe_releasedlabel_14c67a92", "Released by Mastery Path: %{cyoe.releasedLabel}", options)))
    + "</span>\n      ";
  return buffer;
  }

function program21(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <li role=\"presentation\">\n              <a href=\"";
  if (helper = helpers.edit_url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.edit_url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "?return_to=";
  if (helper = helpers.return_to) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.return_to); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "#mastery-paths-editor\" class=\"icon-mastery-path\" tabindex=\"-1\" role=\"menuitem\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title_label': ((depth0 && depth0.title_label)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "edit_mastery_paths_for_title_label_41d81451", "Edit Mastery Paths for %{title_label}", options) : helperMissing.call(depth0, "t", "edit_mastery_paths_for_title_label_41d81451", "Edit Mastery Paths for %{title_label}", options)))
    + "\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "mastery_paths_cc4096c2", "Mastery Paths", options) : helperMissing.call(depth0, "t", "mastery_paths_cc4096c2", "Mastery Paths", options)))
    + "</a>\n          </li>\n          ";
  return buffer;
  }

function program23(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n            <li role=\"presentation\">\n            ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.permissions)),stack1 == null || stack1 === false ? stack1 : stack1['delete']), {hash:{},inverse:self.program(26, program26, data),fn:self.program(24, program24, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            </li>\n          ";
  return buffer;
  }
function program24(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n              <a href=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" id=\"ui-id-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-3\" class=\"delete-item icon-trash\" tabindex=\"-1\" role=\"menuitem\" title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "delete_quiz_142b8099", "Delete Quiz", options) : helperMissing.call(depth0, "t", "delete_quiz_142b8099", "Delete Quiz", options)))
    + "'>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "delete_a6efa79d", "Delete", options) : helperMissing.call(depth0, "t", "delete_a6efa79d", "Delete", options)))
    + "</a>\n            ";
  return buffer;
  }

function program26(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n              <a id=\"ui-id-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-3\" class=\"delete-item icon-trash disabled\" aria-disabled=\"true\" tabindex=\"-1\" role=\"menuitem\" title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "delete_quiz_142b8099", "Delete Quiz", options) : helperMissing.call(depth0, "t", "delete_quiz_142b8099", "Delete Quiz", options)))
    + "'>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "delete_a6efa79d", "Delete", options) : helperMissing.call(depth0, "t", "delete_a6efa79d", "Delete", options)))
    + "</a>\n            ";
  return buffer;
  }

function program28(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <li role=\"presentation\">\n              <a href=\"#\" id=\"ui-id-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-4\" class=\"icon-export migrate\" tabindex=\"-1\" role=\"menuitem\" title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "migrate_quiz_5d0f777", "Migrate Quiz", options) : helperMissing.call(depth0, "t", "migrate_quiz_5d0f777", "Migrate Quiz", options)))
    + "'>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "migrate_67c9f753", "Migrate", options) : helperMissing.call(depth0, "t", "migrate_67c9f753", "Migrate", options)))
    + "</a>\n            </li>\n          ";
  return buffer;
  }

  buffer += "<div id=\"summary_quiz_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.can_update), {hash:{},inverse:self.program(6, program6, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n>\n  <div class=\"ig-row__layout\">\n\n    <div class=\"ig-type-icon\">\n      <i class=\"icon-quiz\" aria-hidden=\"true\"></i>\n    </div>\n\n    <div class=\"ig-info\">\n      <a href=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"ig-title\">\n        ";
  if (helper = helpers.title_label) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title_label); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n      </a>\n      <div class=\"ig-details\">\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showAvailability), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showDueDate), {hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.possible_points_label), {hash:{},inverse:self.noop,fn:self.program(12, program12, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.question_count_label), {hash:{},inverse:self.noop,fn:self.program(14, program14, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n    </div>\n\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.can_update), {hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  </div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  